<div class="item-list-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <div class="grid-buttons">
    <dx-button *ngIf="isFixedNumbers" hint="{{ 'SHARED.ADD' | translate }}" icon="add" (onClick)="add()"></dx-button>
    <dx-button hint="{{ 'SHARED.PRINT' | translate }}" icon="print" (onClick)="print()"></dx-button>
  </div>
  <br />
  <dx-data-grid #distributionNumbersGrid id="printSection" [rtlEnabled]="rtlEnabled"
    [dataSource]="distributionNumberDataSource" [showBorders]="true" [allowColumnReordering]="true"
    [hoverStateEnabled]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true" (onRowClick)="edit($event)"
    (onExporting)="onExporting($event)"
    (onEditorPreparing)="onEditorPreparing($event)"
    [remoteOperations]="{ paging: true, filtering: true, sorting: true, search: true }"
    [paging]="{ pageSize: 20 }">

    <dxo-export [enabled]="true"></dxo-export>
    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
    
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]"
      [showNavigationButtons]="true" [showInfo]="true"
      infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}">
    </dxo-pager>

    <ng-template #filterRowEditor let-options="options">
      <dx-select-box
        [dataSource]="buyerDataSource"
        [value]="options.value"
        valueExpr="buyerId"
        displayExpr="buyerDisplayValue"
        [showClearButton]="true"
        [searchEnabled]="true"
        (onValueChanged)="options.setValue($event.value)"
      >
      </dx-select-box>
    </ng-template>

    <dxi-column 
    dataType="string" 
    name="buyerName" 
    dataField="buyerDisplayName"
    calculateDisplayValue="buyerDisplayName"
    caption="{{ 'DISTRIBUTION_MANAGEMENT.BUYER_NAME' | translate }}">
    </dxi-column>

    <dxi-column dataField="masterDataListRowId" 
    caption="{{ 'DISTRIBUTION_MANAGEMENT.CATEGORY' | translate }}"
    [editorOptions]="{ showClearButton: true }">
      <dxo-lookup [dataSource]="masterDataLookupSource" valueExpr="value" displayExpr="label">
      </dxo-lookup>
    </dxi-column>

    <dxi-column dataType="number" dataField="value"
      caption="{{ 'DISTRIBUTION_MANAGEMENT.DISTRIBUTION_NUMBER_TITLE' | translate }}"
      [editorOptions]="{ showClearButton: true }">
    </dxi-column>

    <dxi-column type="buttons" [width]="70">
      <dxi-button *ngIf="isFixedNumbers" hint="{{ 'SHARED.EDIT' | translate }}" icon="edit"
        [onClick]="edit" [disabled]="!editingEnabled"></dxi-button>
      <dxi-button *ngIf="isFixedNumbers" hint="{{ 'SHARED.DELETE' | translate }}" icon="trash"
        [onClick]="deleteItem" [disabled]="!editingEnabled"></dxi-button>
    </dxi-column>

  </dx-data-grid>
</div>

<distribution-number-component #details (onClosed)="onDetailsComponentClosed($event)"></distribution-number-component>
<confirmation-component #confirmation title="{{ 'DISTRIBUTION_MANAGEMENT.DELETE' | translate }}"
  message="{{ 'DISTRIBUTION_MANAGEMENT.DELETE_MESSAGE_DISTRIBUTION_NUMBERS' | translate }}"
  buttonCloseText="{{ 'SHARED.DELETE' | translate }}" cancellable="true"
  (close)="deleteSelected();"></confirmation-component>